import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Star, Eye, Zap, ShieldCheck, CheckCircle2 } from 'lucide-react';
export const Hero = () => {
  const [viewers, setViewers] = useState(23);
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    const tick = () => {
      setViewers(prev => {
        // small organic fluctuation, kept within a believable range
        const delta = Math.floor(Math.random() * 5) - 2; // -2..+2
        let next = prev + delta;
        if (next < 14) next = 14 + Math.floor(Math.random() * 3);
        if (next > 38) next = 38 - Math.floor(Math.random() * 3);
        return next;
      });
      // random interval so it doesn't feel mechanical
      timeoutId = setTimeout(tick, 2500 + Math.random() * 3500);
    };
    timeoutId = setTimeout(tick, 3000);
    return () => clearTimeout(timeoutId);
  }, []);
  return <section className="relative pt-6 pb-8 md:pt-8 md:pb-12 overflow-hidden" data-id="element-79" data-mp="382p4rap7j9k3">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-gold-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-80" data-mp="3j7zgtn69y0is" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-81" data-mp="3o6u5v6uu4lbc">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-82" data-mp="39b4knaxh4c7o">
          {/* Title */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="md:text-5xl lg:text-6xl mb-4 text-white text-[24px] font-[700] font-['Open_Sans',_sans-serif] w-[328px]" data-id="element-83" data-mp="3e8ecsyc8z1z7">
            ⚖️ Tene todo listo para resolver cualquier caso de consumo
          </motion.h1>

          {/* Mockup Image */}
          <motion.div initial={{
          opacity: 0,
          y: 24,
          scale: 0.96
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} className="w-full max-w-2xl my-4 md:my-5" data-id="element-84" data-mp="2viokchvyisag">
            <img src="https://cdn.magicpatterns.com/uploads/nHWDs4ow69CMhKSLCGy35M/6f5ab64e-5071-4e85-9a3e-0c23f0a128d4.png" alt="Defensa del Consumidor 2026: sistema completo para abogados de consumo con modelos, cartas documento, jurisprudencia y estrategias" className="w-full h-auto drop-shadow-2xl" data-id="element-85" data-mp="nat8vfsf4smt" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col items-center w-full" data-id="element-86" data-mp="161t0ypv7mikb">
            <p className="md:text-xl text-slate-300 font-medium mb-5 text-[14px] font-[Poppins,_sans-serif]" data-id="element-87" data-mp="3lui9cqv5izld">
              Trabajá reclamos de consumo con la seguridad de tener modelos,
              estrategias, jurisprudencia y fundamentos listos para aplicar
              desde el primer caso.
            </p>

            {/* Rating */}
            <div className="flex items-center gap-2 mb-5" data-id="element-88" data-mp="26a9a1lewpcw7">
              <div className="flex gap-0.5" data-id="element-89" data-mp="268oeptkrppxa">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-90" data-mp="2b2agurtb2beu" data-mpi={i} />)}
              </div>
              <span className="text-slate-300 font-semibold text-sm" data-id="element-91" data-mp="2kxud5fbs7c44">
                4.9 (500+ ventas)
              </span>
            </div>

            {/* CTA below rating */}
            <motion.a href="#oferta" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 mb-5 hover:bg-gold-400 font-bold rounded-lg text-lg transition-colors shadow-[0_0_20px_rgba(201,162,74,0.3)] text-[#F1F3F8] bg-[#56C94A]" data-id="element-92" data-mp="2u03kxxfo0rdt">
              QUIERO EL TRATADO AHORA
            </motion.a>

            {/* Trust Badges */}
            <div className="mt-2 flex flex-wrap justify-center items-center gap-4 sm:gap-6 text-sm text-slate-400" data-id="element-93" data-mp="3vigoe8dy4hzd">
              <div className="flex items-center gap-1.5" data-id="element-94" data-mp="e88ww364ai50">
                <Zap className="w-4 h-4 text-gold-500" data-id="element-95" data-mp="9aql850ptotb" />
                Entrega inmediata
              </div>
              <div className="flex items-center gap-1.5" data-id="element-96" data-mp="3hpr3k7a5lj3u">
                <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-97" data-mp="3ho68mgjxfy5g" />
                Pago seguro
              </div>
              <div className="flex items-center gap-1.5" data-id="element-98" data-mp="3cpcvip8jy95t">
                <CheckCircle2 className="w-4 h-4 text-gold-500" data-id="element-99" data-mp="3rgvdutovwfsc" />
                Garantía de 7 días
              </div>
            </div>

            <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-red-500/40 bg-red-500/10 px-4 py-2 text-sm font-semibold text-red-400" data-id="element-100" data-mp="3mniryrblan3a">
              <span className="relative flex h-2.5 w-2.5" data-id="element-101" data-mp="2u06hhfipe5qc">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75" data-id="element-102" data-mp="19i5g4n83ngj9" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-red-500" data-id="element-103" data-mp="1eafbwjvwbatg" />
              </span>
              <Eye className="w-4 h-4" data-id="element-104" data-mp="zlsk3ip30qlc" />
              <span className="tabular-nums" data-id="element-105" data-mp="zimzogreecvy">{viewers}</span> profesionales
              viendo este producto ahora
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};